/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2018/8/1 8:54
 */
import React from 'react'
interface WithLangPropType {
  lang: Lang,
}
const context = React.createContext({} as WithLangPropType)
const { Provider, Consumer } = context

/**
 * 高阶组件，传递 lang
 * @param Component {function | React.Component}
 * @returns {function(*): *}
 */
export default Component => function withLang (props) {
  return (
    <Consumer>
      {({ lang }) => <Component {...props} lang={lang} />}
    </Consumer>
  )
}

export { Provider as LangProvider, context as LangContext, WithLangPropType }
